import React from 'react';

import * as fonts from '../../../util/fonts';

function Header1({children, ...rest}: any) {
  return (
    <h1 style={{...fonts.XL}} {...rest}>
      {children}
    </h1>
  );
}

export default Header1;
